import { Outlet } from 'react-router';

/*
 * Prefer dynamic over static import into this file
 * because static ones will end up in the main bundle
 */
import { getRoutesFromFiles } from '@sorare/routing';

export const routeObjects = [
  {
    element: <Outlet />,
    children: [
      ...getRoutesFromFiles(
        import.meta.glob('./**/(page|layout).tsx'),
        '../../packages/blog/src/pages'
      ),
      {
        path: '*',
        lazy: async () => ({
          Component: (await import('@sorare/core/src/routing/NotFound'))
            .NotFound,
        }),
      },
    ],
  },
];
